import styled from '@emotion/styled'

export const V2L4DashboardRoot = styled.div({
	overflow: 'hidden',
	display: 'grid',
	gridTemplateColumns: 'min(38.2%, 640px) 1fr',
	padding: '2rem',
	gap: '1rem',
})

export const V2L4FpoDashboardRoot = styled(V2L4DashboardRoot)({
	'> *': {
		overflow: 'scroll',
	},
})
